import { List,MenuItem,Select } from "@mui/material"
import React from "react"
import { useContext } from "react"
import Tab from '@mui/material/Tab';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import TabPanel from '@mui/lab/TabPanel';
import { useHistory } from "react-router-dom"
import ContextRouter from "../contextAPI/ContextRouter"
import MainListItems from "./MainListItems"
import { useState } from "react";
import RunQuery from "./RunQuery";
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import PrintIcon from '@mui/icons-material/Print';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import DeleteIcon from '@mui/icons-material/Delete';
import StorageIcon from '@mui/icons-material/Storage';
import AddIcon from '@mui/icons-material/Add';
import "../CSS/userdashboard.css"
import DbManagment from "./DbManagment";
import UploadDatabase from "./UploadDatabase";
import CreateTable from "./CreateTable";
import { deleteResponse } from "../BackendServices/FetchServices";
import { useEffect } from "react";
import TableData from "./TableData";

export default function UserDashboard() {
  const context=useContext(ContextRouter)
  const history=useHistory()
  const [getContext,setContext]=useState(<></>)
  const [getValue,setValue]=useState("0")
  const handleRemoveDatabase=async()=>{
    try{
      let status=window.confirm("You Want To Drop "+context.getDatabase+" Database")
      if(!status){
        return;
      }
      let res=await deleteResponse("/deletedatabase",{dbname:context.getDatabase})
      if(res.status){
          let dbArr=(context.getDatabaseList)
          dbArr=dbArr.filter((item)=>{
              return item.databasename!=context.getDatabase;
          })    
          context.setDatabaseList(dbArr);
          if(dbArr.length>0){
            context.setDatabase(dbArr[0].databasename);
          }
          context.setAlert({status:true,msg:"Database Drop Successfully",color:"green"})
          setDefaultComponent()
      }
      else{
        context.setAlert({status:true,msg:res.err,color:"red"})
      }
    }
    catch(e){
      context.setAlert({status:true,msg:"Internal Error..",color:"yellow"})
    }
  }
const actions = [
  { icon: <FileCopyIcon />, name: 'Create Database' ,click:()=>{handleSetContent(<DbManagment key={1} heading={"Create Db"} isOpen={false}/>)}},
  { icon: <CloudUploadIcon />, name: 'Upload Database',click:()=>{handleSetContent(<UploadDatabase/>)} },
  { icon: <BackupTableIcon />, name: 'Create Table' ,click:()=>{handleSetContent(<CreateTable fetchTable={context.fetchTable} setComponent={handleSetContent}/>)}},
  { icon: <DeleteIcon />, name: 'Drop Database',click:handleRemoveDatabase },
  // { icon: <PrintIcon />, name: 'Download Database', },
];
  const handleChange=(e,val)=>{
    setValue(val)
  }
  const handleChangeVal=(val)=>{
      context.setDatabase(val.target.value)
  }
  const handleSetContent=(component)=>{
      setContext(component);
      setValue("1")
  }
  if(!localStorage.getItem("auth")){
    history.replace({pathname:"/"})
  }
  const setDefaultComponent=()=>{
    if(context.getDatabaseList.length==0){
        handleSetContent(<DbManagment key={1} heading={"Create Db"} isOpen={false}/>)
    }  
    if(context.getTableList.length==0){
      handleSetContent(<CreateTable fetchTable={context.fetchTable} setComponent={handleSetContent}/>)
    }
    else{
      context.setTable(context.getTableList[0].name)
      handleSetContent(<TableData handleSetContent={handleSetContent} fetchTable={context.fetchTable}/>)
    }
  }
  useEffect(()=>{
      setDefaultComponent()
  },[context.getTableList])
  return(
  <TabContext value={getValue}>
    <div className='dashboard-main-div'>
        {/* Animated Background */}
        <div className='dashboard-background'>
          <div className='bg-shape bg-shape-1'></div>
          <div className='bg-shape bg-shape-2'></div>
          <div className='bg-shape bg-shape-3'></div>
        </div>
        
        <div className='dashboard-sub-div'>
            <div className='dashboard-top-bar'>
              <div className='databases-list'>
                <div className='database-selector-wrapper'>
                  <StorageIcon className='database-icon' />
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={context.getDatabase}
                    label="Database"
                    className='database-select'
                    onChange={handleChangeVal}
                  >
                    {context.getDatabaseList.map((item)=>{
                      return <MenuItem key={item.databasename} value={item.databasename} className='database-menu-item'>{item.databasename}</MenuItem>
                    })
                  }
                  </Select>
                </div>
              </div>
              <div className="switch-options">
                <TabList onChange={handleChange} className='custom-tab-list'>
                  <Tab label="Execute Query" value="0" className='custom-tab' />
                  <Tab label="Data" value="1" className='custom-tab' />
                </TabList>
              </div>
              <div className="action-buttons">
                <button className="add-new btn-primary" onClick={()=>{handleSetContent(<DbManagment key={1} heading={"Create Db"} isOpen={false}/>)}}>
                  <AddIcon className='btn-icon' />
                  <span>Create Database</span>
                </button>
                <button className="add-new btn-secondary" onClick={()=>{handleSetContent(<UploadDatabase/>)}}>
                  <CloudUploadIcon className='btn-icon' />
                  <span>Upload Database</span>
                </button>
              </div>
            </div>
            <div className='dashboard-bottom-bar'>
                <div className='dashboard-left-window'>
                    <div className='sidebar-header'>
                      <span className='sidebar-icon'>📋</span>
                      <span className='sidebar-title'>Actions</span>
                    </div>
                    <List className='custom-list'>
                      <MainListItems handleSetContent={handleSetContent} handleRemoveDatabase={handleRemoveDatabase}/>
                    </List>
                </div>
                <div className='dashboard-right-window'>
                        <TabPanel value="0" className='custom-tab-panel'>
                              <RunQuery setValue={setValue} setComponent={handleSetContent}/>
                        </TabPanel>
                        <TabPanel value="1" className='custom-tab-panel'>
                              {getContext}
                        </TabPanel>
                </div>
                <div className='speed-dial-wrapper'>
                  <SpeedDial
                      ariaLabel="SpeedDial basic example"
                      className='custom-speed-dial'
                      sx={{ position:"absolute",bottom:16,right:16 }}
                      icon={<SpeedDialIcon />}
                    >
                      {actions.map((action) => (
                        <SpeedDialAction
                          key={action.name}
                          icon={action.icon}
                          tooltipTitle={action.name}
                          onClick={action.click}
                          className='speed-dial-action'
                        />
                      ))}
                    </SpeedDial>
                </div>
            </div>
        </div>
    </div>
  </TabContext>
  )
}